import { FC, useEffect } from 'react';
import { onCLS, onFCP, onFID, onLCP, onTTFB, ReportCallback } from 'web-vitals';
import {
  useAnalyticsPost,
  NarvarEventTypes,
  NarvarEventComponents,
} from './useAnalyticsPost';

export const WebVitals: FC = () => {
  const logEvent = useAnalyticsPost();

  useEffect(() => {
    const onReport: ReportCallback = ({ name, value }) => {
      logEvent({
        eventType: NarvarEventTypes.WEB_VITAL,
        eventId: name,
        pageLoadMs: value,
        eventComponent: NarvarEventComponents.APP_ROUTER_TRACKING,
      });
    };
    onCLS(onReport);
    onFCP(onReport);
    onFID(onReport);
    onLCP(onReport);
    onTTFB(onReport);
  }, [logEvent]);

  return null;
};
